import { render, staticRenderFns } from "./ContentItem.vue?vue&type=template&id=4dda8908&scoped=true&"
import script from "./ContentItem.vue?vue&type=script&lang=js&"
export * from "./ContentItem.vue?vue&type=script&lang=js&"
import style0 from "./ContentItem.vue?vue&type=style&index=0&id=4dda8908&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dda8908",
  null
  
)

export default component.exports